import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-boton-primario',
  templateUrl: './boton-primario.component.html',
  styleUrls: ['./boton-primario.component.scss']
})

export class BotonPrimarioComponent {
  @Input("boton_texto") boton_texto: string;
  @Input("estado") estado: string;
  @Input("titulo") titulo: string = "";
  @Output("boton_funcion") boton_funcion: EventEmitter<any> = new EventEmitter<any>();
  @Input("disabled") disabled: boolean = false;
  @Input("spinner") spinner: boolean = false;
  @Input("clase") clase: string = "verde";

  ngOnInit() {

  }

  ejecutarFuncion() {
    this.boton_funcion.emit();
  }
}
